var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagSamoa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16358)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 24.8365 24.8365 32 16 32C7.1635 32 0 24.8365 0 16C5.49563 10.5044 10.1565 5.8435 16 0C24.8365 0 32 7.1635 32 16Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 16C16 7.1635 16 6.12175 16 0C7.1635 0 0 7.1635 0 16H16Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8159 10.4348L13.0749 11.232H13.9131L13.2349 11.7246L13.494 12.5218L12.8159 12.0291L12.1378 12.5218L12.3968 11.7246L11.7187 11.232H12.5568L12.8159 10.4348Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.60579 4.17383L9.03747 5.50252H10.4345L9.30422 6.32345L9.73604 7.65208L8.60579 6.83089L7.4756 7.65208L7.90735 6.32345L6.77716 5.50252H8.17404L8.60579 4.17383Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7796 5.56494L13.2113 6.89369H14.6082L13.4781 7.71463L13.9097 9.04325L12.7796 8.22207L11.6494 9.04325L12.0812 7.71463L10.951 6.89369H12.3479L12.7796 5.56494Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.48079 11.1304L9.91254 12.4591H11.3094L10.1792 13.28L10.611 14.6086L9.48079 13.7875L8.3506 14.6086L8.78235 13.28L7.65216 12.4591H9.0491L9.48079 11.1304Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.8235 7.6521L6.25525 8.98079H7.65218L6.52193 9.80172L6.95368 11.1304L5.8235 10.3092L4.69337 11.1304L5.12506 9.80172L3.99493 8.98079H5.39181L5.8235 7.6521Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16358"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagSamoa);
export default __webpack_public_path__ + "static/media/flag_samoa.b64894d603c93ca1dd6ff1f33b6bd659.svg";
export { ForwardRef as ReactComponent };